import Marquee from "react-fast-marquee";

const ITEMS = [
  "Open 24 hours, every day",
  "Emergency care, any hour",
  "Cats · Dogs · Birds",
  "Compassion at every visit",
];

export const EditorialMarquee = () => (
  <section
    data-testid="marquee-section"
    className="bg-sa-beige border-y border-sa-espresso/5 py-8 sm:py-10 overflow-hidden"
  >
    <Marquee speed={32} gradient={false} autoFill>
      {ITEMS.map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display italic font-light text-3xl sm:text-4xl lg:text-5xl text-sa-espresso px-8">
            {item}
          </span>
          <span className="text-sa-bronze text-3xl sm:text-4xl">—</span>
        </div>
      ))}
    </Marquee>
  </section>
);

export default EditorialMarquee;
